// Explanatory intermediate screen shown once the visitor picks the demo
// route (either via the landing "start demo" card or via a `?demo=1`
// URL). Provides context on what Scan-and-Call does and only advances
// to the actual triage after the user clicks "Weiter".
import React from "react";
import { ArrowRight, Volume2, PlayCircle } from "lucide-react";
import { useI18n } from "../lib/i18n";

const DGUV_POSTER =
    "https://customer-assets.emergentagent.com/job_rapid-response-213/artifacts/6653rwlt_204-001-overlay%20%282%29.jpg";

export const DemoIntroScreen = ({ onContinue }) => {
    const { t } = useI18n();
    return (
        <section
            data-testid="demo-intro-section"
            className="anim-fade-up py-4"
        >
            <div className="rounded-3xl bg-white shadow-lg border border-zinc-200 overflow-hidden">
                <div className="bg-[#0F8040] text-white px-5 sm:px-8 py-5 sm:py-6">
                    <div className="flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.18em] text-white/80 font-semibold">
                        <PlayCircle className="w-4 h-4" />
                        {t("demo_intro_eyebrow")}
                    </div>
                    <h1 className="mt-1.5 font-display font-black text-3xl sm:text-4xl leading-tight tracking-tight">
                        {t("demo_intro_title")}
                    </h1>
                </div>

                <div className="p-5 sm:p-8 grid gap-6 md:grid-cols-[220px_1fr] items-start">
                    <div className="mx-auto md:mx-0 max-w-[220px]">
                        <img
                            data-testid="demo-intro-poster"
                            src={DGUV_POSTER}
                            alt={t("hero_poster_alt")}
                            className="w-full rounded-xl shadow-md ring-1 ring-zinc-200 rotate-[1.5deg]"
                            loading="eager"
                        />
                    </div>
                    <div className="space-y-4 text-sm sm:text-base text-zinc-700 leading-relaxed">
                        <p>{t("demo_intro_body_1")}</p>
                        <p>{t("demo_intro_body_2")}</p>
                        <div className="flex items-start gap-3 rounded-2xl bg-amber-50 border border-amber-200 px-4 py-3 text-amber-900">
                            <Volume2
                                className="w-5 h-5 mt-0.5 flex-shrink-0"
                                strokeWidth={2.25}
                            />
                            <div className="text-sm leading-snug">
                                {t("demo_intro_volume_tip")}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="px-5 sm:px-8 pb-6 sm:pb-8">
                    <button
                        data-testid="demo-intro-continue"
                        type="button"
                        onClick={onContinue}
                        className="w-full sm:w-auto sm:min-w-[220px] inline-flex items-center justify-center gap-2 bg-zinc-900 hover:bg-zinc-800 active:scale-[0.98] text-white font-display font-bold text-base px-6 py-3.5 rounded-xl transition"
                    >
                        {t("demo_intro_continue")}
                        <ArrowRight className="w-5 h-5" strokeWidth={2.5} />
                    </button>
                </div>
            </div>
        </section>
    );
};
